module.exports = __webpack_public_path__ + "img/likewise-logo_red.678b935c.svg";